const reduxConstants = {
  STORE_NAME: 'config_store',
  actions: {
    CREATE: 'create',
    UPDATE: 'update',
    TRIGGER_NOTIFICATION_REFRESH: 'TRIGGER_NOTIFICATION_REFRESH',
    TRIGGER_REFETCH: 'TRIGGER_REFETCH',
  },
  config: {
    LOGIN: 'login',
    APP_STATE: 'appState',
    TABLE_SCHEMA: 'table-schema',
    DASH_TABLE_SCHEMA: 'dash-table-schema',
    CHART_SETTINGS: 'chartSettings',
    DASH_SETTINGS: 'dashSettings',
    REPORT_SETTINGS: 'reportSettings',
    KPI_SETTINGS: 'kpiSettings',
    READY_FOR_QUERY: 'readyForQuery',
    APP_SCHEMA: 'appSchema',
    DATA_TABLE: 'appDatatable',
    KPI_ALL_SCHEMA: 'kpiAllSchema',
    ANALYTICS_SCHEMA: 'analyticsSchema',
    USER_SCHEMA: 'userSchema',
    ALL_APPUSERS_DATA: 'allAppUsersData',
    APP_MLS: 'appMLS',
    USER_ACCESS_SCHEMA: 'userAccessSchema',
    PLUGINS_SCHEMA: 'pluginsSchema',
    APP_STATUS: {
      TOAST: 'appStatus.toast',
      ERROR_TOAST: 'appStatus.errorToast',
      LOADING: 'appStatus.loading',
    },
    ALL_TABLES: 'allTables',
    JOIN_TABLES: 'appJointable',
    CUSTOM_TABLES: 'appCustomtable',
    FILTERS: 'filters',
    DASH_FILTERS: 'dash_filters',
    DATE_TIME_TOGGLE: 'dateTimeToggle',
    NOTIFICATIONS: 'notifications',
    REFETCHDATA: 'refetchData',
    WEB_VERSION: 'webVersion',
    SHOW_VERSION_MISMATCH_POPUP: 'showVersionMismatchPopup',
    SHOW_APP_VERSION_MISMATCH_POPUP: 'showAppVersionMismatchPopup',
  },
};

export default reduxConstants;
